import { useEffect } from "react";

import { analytics } from "../../analytics/analyticsEvents";
import { getPlatformAdapter } from "../../platform/PlatformAdapter";

/**
 * Brackets a task screen with the platform gameplay session: signals
 * gameplayStart on mount and gameplayStop on unmount (no ads inside gameplay).
 * When a task type is given, also emits task_started on mount.
 */
export function useGameplaySession(taskType?: string): void {
  useEffect(() => {
    const adapter = getPlatformAdapter();
    adapter.gameplayStart();
    if (taskType) {
      analytics.taskStarted({ type: taskType });
    }
    return () => adapter.gameplayStop();
  }, [taskType]);
}
